import { observer } from "mobx-react-lite";
import { useMatchStatsStore } from "../../../stores/StoreContext";
import { Colors } from "../../../utils/colors";
import { TCText } from "../../../components/TCText/TCText";
import { AllShots } from "../../../stores/matchDetails/MatchStatsStore";

export const MatchShotPatterns = observer(() => {
  const matchStatsStore = useMatchStatsStore();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 10,
        overflowX: "auto",
        whiteSpace: "nowrap",
        paddingBottom: 10,
        marginBottom: 10,
      }}
    >
      {Array.from(matchStatsStore.filteredShotsMap.keys()).map((item) => (
        <div style={{ display: "inline-block" }} key={item}>
          <ShotPatternFilterItem item={item} />
        </div>
      ))}
    </div>
  );
});

interface ShotPatternFilterItemProps {
  item: string;
}

export const ShotPatternFilterItem = observer(
  ({ item }: ShotPatternFilterItemProps) => {
    const matchStatsStore = useMatchStatsStore();
    return (
      <div
        onClick={() => matchStatsStore.setSelectedFilteredShots(item)}
        style={{
          borderRadius: 12,
          padding: "8px 16px",

          backgroundColor:
            item === matchStatsStore.selectedFilteredShots
              ? Colors.darkBrown
              : Colors.lightGreyBackground,
        }}
      >
        <TCText
          value={`${
            item === AllShots
              ? item
              : item
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")
          } 
          ${
            item === matchStatsStore.selectedFilteredShots
              ? `(${matchStatsStore.filteredShotsMap.get(item)?.length})`
              : ""
          }`}
          style={{
            fontWeight: "500",
            fontSize: 11,
            color:
              item === matchStatsStore.selectedFilteredShots
                ? Colors.white
                : Colors.black,
          }}
        />
      </div>
    );
  }
);
